import { ROUTES } from '@constants/routes';
import { MTAdminBreadcrumbs } from '../components/breadcrumbs/MTAdminBreadcrumbs';
import StockExchangeSettings from '@features/stock-exchange-settings';

export const StockExchangeSettingsRoute = () => {
  return (
    <StockExchangeSettings
      baseRoute={ROUTES.MATERIALITY_TRACKER_COMPANY_SETTINGS}
      BreadcrumbsComponent={MTAdminBreadcrumbs}
    />
  );
};
